<template>
    <servicos
        :permitirAprovar="$temAcessoView('GESCON-UABS-SERV-00')"
        :permitirReprovar="$temAcessoView('GESCON-UABS-SERV-00')"
        :permiteDetalhar="$temAcessoView('GESCON-UABS-SERV-00')"
        rotaDetalhar="Gescon_Uabs_Servicos_Detalhar"
        rotaListagem="Gescon_Uabs_Servicos_Listagem"
    ></servicos>
</template>

<script>
import ServicosServicos from './ServicosServicos'
import Servicos from '../../aprovadores/Comprometimentos'

export default {
    name: 'UabsServicos',
    
    components: {
        Servicos
    },

    data() {
        return {
            servicosServicos: ServicosServicos
        }
    },

    provide() {
        return {
            servicosServicos: this.servicosServicos
        }
    }
}
</script>
